// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 店铺权限管理 -- 列表
 */
export function merchantMenuListApi(data: any) {
    return request({
        url: 'merchant/menu/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺权限管理 -- 新增表单
 */
export function merchantMenuCreateApi() {
    return request({
        url: 'merchant/menu/create/form',
        method: 'get',
    });
}

/**
 * @description 店铺权限管理 -- 编辑表单
 */
export function merchantMenuUpdateApi(id: number | string) {
    return request({
        url: `merchant/menu/update/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺权限管理 -- 删除
 */
export function merchantMenuDeleteApi(id: number | string) {
    return request({
        url: `merchant/menu/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 店铺列表 -- 列表
 */
export function merchantListApi(data: any) {
    return request({
        url: 'system/merchant/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺列表 -- 详情
 */
export function merchantDetail(id: number | string) {
    return request({
        url: `system/merchant/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺列表 -- 新增表单
 */
export function merchantCreateApi() {
    return request({
        url: 'system/merchant/create/form',
        method: 'get',
    });
}

/**
 * @description 店铺列表 -- 新增
 */
export function merchantCreate(data: any) {
    return request({
        url: 'system/merchant/create',
        method: 'post',
        data,
    });
}

/**
 * @description 店铺列表 -- 编辑表单
 */
export function merchantUpdateApi(id: number | string) {
    return request({
        url: `system/merchant/update/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺列表 -- 编辑
 */
export function merchantUpdate(id: number | string, data: any) {
    return request({
        url: `system/merchant/update/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 店铺列表 -- 删除
 */
export function merchantDeleteApi(id: number | string) {
    return request({
        url: `system/merchant/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 店铺列表 -- 删除(表单)
 */
export function merchantDeleteForm(id: number | string) {
    return request({
        url: `system/merchant/delete/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 店铺列表 -- 修改开启状态
 */
export function merchantStatuseApi(id: number | string, status: number) {
    return request({
        url: `system/merchant/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 店铺列表 -- 修改密码
 */
export function merchantPasswordApi(id: number | string) {
    return request({
        url: `system/merchant/password/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺分类 -- 列表
 */
export function categoryListApi(data: any) {
    return request({
        url: 'system/merchant/category/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺分类 -- 新增表单
 */
export function categoryCreateApi() {
    return request({
        url: 'system/merchant/category/form',
        method: 'get',
    });
}

/**
 * @description 店铺分类 -- 编辑表单
 */
export function categoryUpdateApi(id: number | string) {
    return request({
        url: `system/merchant/category/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺分类 -- 删除
 */
export function categoryDeleteApi(id: number | string) {
    return request({
        url: `system/merchant/category/${id}`,
        method: 'delete',
    });
}

/**
 * @description 店铺对账 -- 订单列表
 */
export function merOrderListApi(id: number | string, data: any) {
    return request({
        url: `merchant/order/lst/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺对账 -- 订单备注
 */
export function orderMarkApi(id: number | string) {
    return request({
        url: `merchant/order/mark/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 店铺对账 -- 退款订单列表
 */
export function refundOrderListApi(id: number | string, data: any) {
    return request({
        url: `merchant/order/refund/lst/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 退款订单 -- 订单备注
 */
export function refundMarkApi(id: number | string) {
    return request({
        url: `merchant/order/refund/mark/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 对账订单 -- 发起对账单
 */
export function reconciliationApi(id: number | string, data: any) {
    return request({
        url: `merchant/order/reconciliation/create/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 对账订单 -- 发起对账单
 */
export function merchantLoginApi(merId: number | string) {
    return request({
        url: `system/merchant/login/${merId}`,
        method: 'post',
    });
}

/**
 * @description 申请管理 -- 列表
 */
export function intentionLstApi(data: any) {
    return request({
        url: 'merchant/intention/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 申请管理 -- 备注
 */
export function auditApi(merId: number | string) {
    return request({
        url: `merchant/intention/mark/${merId}/form`,
        method: 'get',
    });
}

/**
 * @description 申请管理 -- 删除
 */
export function intentionDelte(merId: number | string) {
    return request({
        url: `merchant/intention/delete/${merId}`,
        method: 'delete',
    });
}

/**
 * @description 申请管理 -- 修改状态
 */
export function intentionStatusApi(merId: number | string) {
    return request({
        url: `merchant/intention/status/${merId}/form`,
        method: 'get',
    });
}

/**
 * @description 申请管理 -- 编辑复制次数
 */
export function changeCopyApi(merId: number | string) {
    return request({
        url: `system/merchant/changecopy/${merId}/form`,
        method: 'get',
    });
}

/**
 * @description 申请管理 -- 入驻协议详情
 */
export function intentionAgreeInfo() {
    return request({
        url: 'agreement/sys_intention_agree',
        method: 'get',
    });
}

/**
 * @description 申请管理 -- 入驻协议保存
 */
export function intentionAgreeUpdate(data: any) {
    return request({
        url: 'agreement/sys_intention_agree',
        method: 'post',
        data,
    });
}

/**
 * @description 店铺类型 -- 获取说明
 */
export function getStoreTypeApi(key: string) {
    return request({
        url: `agreement/${key}`,
        method: 'get',
    });
}

/**
 * @description 店铺类型 -- 编辑说明
 */
export function updateStoreTypeApi(type: string, data: any) {
    return request({
        url: `agreement/${type}`,
        method: 'post',
        data,
    });
}

/**
 * @description 店铺列表 -- 开启关闭
 */
export function merchantIsCloseApi(id: number | string, status: number) {
    return request({
        url: `system/merchant/close/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 店铺列表 -- 开启店铺数
 */
export function merchantCountApi(data: any) {
    return request({
        url: 'system/merchant/count',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺类型 -- 创建店铺类型
 */
export function storeTypeCreateApi(data: any) {
    return request({
        url: 'merchant/type/create',
        method: 'post',
        data,
    });
}

/**
 * @description 店铺类型 -- 列表
 */
export function storeTypeLstApi(data: any) {
    return request({
        url: 'merchant/type/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺类型 -- 店铺权限
 */
export function storeJurisdictionApi() {
    return request({
        url: 'merchant/mer_auth',
        method: 'get',
    });
}

/**
 * @description 店铺类型 -- 创建店铺类型
 */
export function storeTypeUpdateApi(id: number | string, data: any) {
    return request({
        url: `merchant/type/update/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 店铺类型列表 -- 删除
 */
export function storeTypeDeleteApi(id: number | string) {
    return request({
        url: `merchant/type/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 店铺类型列表 -- 备注
 */
export function merchantTypeMarkForm(id: number | string) {
    return request({
        url: `merchant/type/mark/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺类型列表 -- 详情
 */
export function merchantTypeDetailApi(id: number | string) {
    return request({
        url: `/merchant/type/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺类型 -- 获取选择项
 */
export function getstoreTypeApi() {
    return request({
        url: 'merchant/type/options',
        method: 'get',
    });
}

/**
 * @description 店铺分类 -- 获取选择项
 */
export function getMerCateApi() {
    return request({
        url: 'system/merchant/category/options',
        method: 'get',
    });
}

/**
 * @description 服务申请 -- 列表
 */
export function getApplymentLst(data: any) {
    return request({
        url: 'system/applyments/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 服务申请 -- 审核
 */
export function applymentStatusApi(id: number | string, data: any) {
    return request({
        url: `system/applyments/status/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 服务申请 -- 详情
 */
export function applymentDetailApi(id: number | string) {
    return request({
        url: `system/applyments/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 店铺 -- 分账列表
 */
export function applymentLstApi(data: any) {
    return request({
        url: 'profitsharing/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺 -- 分账（立即分账）
 */
export function splitAccountApi(id: number | string) {
    return request({
        url: `profitsharing/again/${id}`,
        method: 'post',
    });
}

/**
 * @description 分账申请 -- 备注
 */
export function splitAccountMark(id: number | string) {
    return request({
        url: `system/applyments/mark/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 分账管理 -- 导出
 */
export function ledgerManageExportApi(data: any) {
    return request({
        url: 'profitsharing/export',
        method: 'get',
        params: data,
    });
}

/**
 * @description 缴存保证金 -- 列表
 */
export function marginLstApi(data: any) {
    return request({
        url: 'margin/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 待缴保证金 -- 列表
 */
export function marginDepositLstApi(data: any) {
    return request({
        url: 'margin/make_up',
        method: 'get',
        params: data,
    });
}

/**
 * @description 待缴保证金 -- 线下付款
 */
export function marginPaymentApi(id: number | string) {
    return request({
        url: `margin/local/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 退回保证金 -- 列表
 */
export function marginRefundLstApi(data: any) {
    return request({
        url: 'margin/refund/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 退回保证金 -- 审核
 */
export function marginRefundStatus(id: number | string) {
    return request({
        url: `margin/refund/status/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 退回保证金 -- 备注
 */
export function marginRefundMark(id: number | string) {
    return request({
        url: `margin/refund/mark/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 退回保证金 -- 退回信息
 */
export function marginRefundInfo(id: number | string) {
    return request({
        url: `margin/refund/show/${id}`,
        method: 'get',
    });
}

/**
 * @description 退回保证金 -- 扣费记录
 */
export function marginDeductionRecord(id: number | string, data: any) {
    return request({
        url: `margin/list/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 退回保证金 -- 保证金扣费
 */
export function marginDeductionForm(id: number | string) {
    return request({
        url: `margin/set/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 店铺详情 -- 操作记录
 */
export function merchantOperateLog(id: number | string, data: any) {
    return request({
        url: `system/merchant/get_operate_list/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 店铺详情--设置虚拟关注数量
 */
export function merchantCareFicti(id: number | string) {
    return request({
        url: `system/merchant/care_ficti/form/${id}`,
        method: 'get',
    });
}


//3.4
/**
 * @description 店铺列表 -- 创建店铺
 */
export function createStoreApi(data:any) {
    return request({
        url: `system/merchant/businessCreate`,
        method: 'post',
        data,
    });
}
